import { Dispatch, Action } from 'redux';
import axios from 'axios';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { getLiveUpdateValidationsAPI, restartLiveUpdateValidationAPI, bulkRestartDelayedLiveUpdateValidationsAPI } from '../../config/config'

// Action types
export const GET_LIVE_UPDATE_VALIDATIONS_REQUEST = 'GET_LIVE_UPDATE_VALIDATIONS_REQUEST';
export const GET_LIVE_UPDATE_VALIDATIONS_SUCCESS = 'GET_LIVE_UPDATE_VALIDATIONS_SUCCESS';
export const GET_LIVE_UPDATE_VALIDATIONS_FAILURE = 'GET_LIVE_UPDATE_VALIDATIONS_FAILURE';

export const RESET_LIVE_UPDATE_VALIDATIONS_STATE = 'RESET_LIVE_UPDATE_VALIDATIONS_STATE'

interface GetLiveUpdateValidationsRequest extends Action<typeof GET_LIVE_UPDATE_VALIDATIONS_REQUEST> { }
interface GetLiveUpdateValidationsSuccess extends Action<typeof GET_LIVE_UPDATE_VALIDATIONS_SUCCESS> {
    payload: { validations: any[], pagination: any }
}
interface GetLiveUpdateValidationsFailure extends Action<typeof GET_LIVE_UPDATE_VALIDATIONS_FAILURE> {
    payload: string
}

interface ResetLiveUpdateValidationsState extends Action<typeof RESET_LIVE_UPDATE_VALIDATIONS_STATE> { }

export type ActionTypes = GetLiveUpdateValidationsRequest | GetLiveUpdateValidationsSuccess | GetLiveUpdateValidationsFailure
    | ResetLiveUpdateValidationsState

// Action creators
const getLiveUpdateValidationsRequest = (): GetLiveUpdateValidationsRequest => ({ type: GET_LIVE_UPDATE_VALIDATIONS_REQUEST });
const getLiveUpdateValidationsSuccess = (data: any[], pagination: any): GetLiveUpdateValidationsSuccess => ({ 
    type: GET_LIVE_UPDATE_VALIDATIONS_SUCCESS, 
    payload: { validations: data, pagination } 
});
const getLiveUpdateValidationsFailure = (error: string): GetLiveUpdateValidationsFailure => ({ type: GET_LIVE_UPDATE_VALIDATIONS_FAILURE, payload: error });

const resetLiveUpdateValidationsState = (): ResetLiveUpdateValidationsState => ({ type: RESET_LIVE_UPDATE_VALIDATIONS_STATE })

// Async action creators
const getLiveUpdateValidations = (params?:any) => {
    return async (dispatch: Dispatch) => {
        try {
            let query = ''
            if(params){
                Object.keys(params)?.map((key, i)=>{
                    if(i===0){
                        query = `?${key}=${params[key]}`
                    }else{
                        query = query + `&${key}=${params[key]}`
                    }
                })
            }
            if(params?.page <= 0){
                dispatch(getLiveUpdateValidationsRequest());
            }
            const response = await getLiveUpdateValidationsAPI(query)
            console.log(response)
            dispatch(getLiveUpdateValidationsSuccess(response?.data?.validations || [], response?.data?.pagination || {}))

        } catch (error: any) {
            console.log('error', error)
            dispatch(getLiveUpdateValidationsFailure(error.message));
        }
    };
};

const resetAll = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
    return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
        dispatch(resetLiveUpdateValidationsState())
    };
}

const restartLiveUpdateValidation = (uuid: string) => {
    return async (dispatch: Dispatch) => {
        try {
            const response = await restartLiveUpdateValidationAPI(uuid);
            if(response?.status === 200){
                return response.data;
            } else {
                throw new Error(response?.data?.message || 'Something went wrong');
            }
        } catch (error: any) {
            console.log('error', error)
            throw error;
        }
    };
};

const bulkRestartDelayedLiveUpdateValidations = () => {
    return async (dispatch: Dispatch) => {
        try {
            const response = await bulkRestartDelayedLiveUpdateValidationsAPI();
            if(response?.status === 200){
                return response.data;
            } else {
                throw new Error(response?.data?.message || 'Something went wrong');
            }
        } catch (error: any) {
            console.log('error', error)
            throw error;
        }
    };
};

const actions = {
    getLiveUpdateValidations,
    restartLiveUpdateValidation,
    bulkRestartDelayedLiveUpdateValidations,
    resetAll
}

export default actions
